import React from 'react';

const DealsLoader = ({ rows }) => {
  const rowsCountArray = Array.from({ length: rows ? rows : 1 }, (v, i) => i);

  return rowsCountArray
    .map((item) => (
      <React.Fragment key={item}>
        <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
          <div className="deal-item-skeleton">
            {/* <DealItemLoader /> */}
          </div>
        </div>
        <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
          <div className="deal-item-skeleton">
            {/* <DealItemLoader /> */}
          </div>
        </div>
        <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
          <div className="deal-item-skeleton">
            {/* <DealItemLoader /> */}
          </div>
        </div>
        <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
          <div className="deal-item-skeleton">
            {/* <DealItemLoader /> */}
          </div>
        </div>
      </React.Fragment>
    ));
};

export default DealsLoader;
